import { render, staticRenderFns } from "./WorkIconGlobalSearch.vue?vue&type=template&id=34e0964b"
import script from "./WorkIconGlobalSearch.vue?vue&type=script&lang=js"
export * from "./WorkIconGlobalSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports